// tslint:disable
import * as React from "react";
import * as _ from "lodash";
import * as classNames from "classnames";

import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs
} from "react-google-maps";

import {
  Alignment,
  Classes as mpdClasses,
  MPDButton,
  MPDIcon,
  States
} from "src/mpd-library";

import { OverlayView } from "react-google-maps";

import { Text } from "@blueprintjs/core";

import { compose, withProps, lifecycle } from "recompose";

import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

import SearchBox, {
  SearchBoxProps
} from "react-google-maps/lib/components/places/SearchBox";

import DrawingManager from "react-google-maps/lib/components/drawing/DrawingManager";

import { ZoomControls } from "./zoom-controls";

import { Shapes } from "./shapes";

import mapStyles from "./default.json";

import { DrawControls } from "./draw-controls";

import { List } from "./list/list";

import "./styles.css";

import { GOOGLE_API_KEY } from "../../../../../App/globals";

import * as marker from "./marker.png";
import * as marker2x from "./marker@2x.png";

const refs = {
  list: []
};

export const GeoMap = compose(
  withProps(props => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: (
      <div
        style={{
          height: `100%`
        }}
      />
    ),
    mapElement: <div style={props.style} />
  })),
  lifecycle({
    componentDidMount() {
      document.addEventListener(
        "keydown",
        event => {
          if (event.key === "Escape") {
            if (this.state.currentMarker) {
              this.setState({ currentMarker: null });
            }
            if (this.state.infoBoxActive) {
              this.setState({ infoBoxActive: false, saveActive: false });
            }
          } else if (event.key === "Enter") {
            if (this.state.infoBoxActive && !this.state.saveActive) {
              this.setState({ saveActive: true });
            } else if (this.state.infoBoxActive && this.state.saveActive) {
              this.state.onSaveLayerClick(event);
            }
          }
        },
        false
      );
    },
    componentWillMount() {
      const {
        zoom,
        hideControls,
        hideDrawControls,
        hideGps,
        boxClass,
        hideSearchControls,
        hideZoomControls,
        hideList,
        drawingMode,
      } = this.props;

      setTimeout(() => {
        this.setState({showMap: true})
      }, 100);

      this.setState({
        bounds: null,
        radius: null,
        drawableItem: null,
        boxClass: boxClass || '',
        drawingMode: drawingMode || null,
        controlsActive: true,
        hideGps: hideGps || false,
        hideList: hideList || false,
        hideControls: hideControls || false,
        hideDrawControls: hideDrawControls || false,
        hideZoomControls: hideZoomControls || false,
        hideSearchControls: hideSearchControls || false,
        alignControls: Alignment.LEFT,
        drawableList: [],
        listItemActive: null,
        currentShapeActive: true,
        zoomControlsActive: true,
        infoBoxActive: false,
        saveActive: false,
        showMap: false,
        zoom: zoom || 15,
        warningContent: {},
        onShapeMounted: shape => {
          refs.shape = shape;
        },
        onZoomChanged: (event, type) => {
          let zoom = this.state.zoom;
          if (type === "zoom-in") {
            zoom++;
          } else if (type === "zoom-out") {
            zoom--;
          }
          this.setState({ zoom });
        },
        onShapeComplete: (shape, type) => {
          let center;
          let currentShape;
          const drawableItem = this.state.drawableItem;

          if (drawableItem !== null) {
            drawableItem.setMap(null);
          }
          if (type === "circle") {
            center = shape.getCenter();
            currentShape = {
              type,
              center,
              bounds: shape.getBounds(),
              radius: shape.getRadius()
            };
          } else if (type === "rectangle") {
            const bounds = shape.getBounds();
            center = bounds.getCenter();
            currentShape = {
              type,
              center,
              bounds
            };
          } else if (type === "polygon") {
            const paths = shape.getPath().getArray();
            let path = JSON.parse(JSON.stringify(paths[0]));

            let maxLat = path.lat;
            let minLat = path.lat;
            let maxlng = path.lng;
            let minLng = path.lng;

            for (let i = 0; i < paths.length; i++) {
              path = JSON.parse(JSON.stringify(paths[i]));
              if (path.lat > maxLat) {
                maxLat = path.lat;
              }
              if (path.lat < minLat) {
                minLat = path.lat;
              }
              if (path.lng > maxlng) {
                maxlng = path.lng;
              }
              if (path.lng < minLng) {
                minLng = path.lng;
              }
            }
            center = {
              lat: (maxLat + minLat) / 2,
              lng: (maxlng + minLng) / 2
            };
            currentShape = {
              type,
              center,
              paths
            };
          }
          this.setState({
            center,
            drawableItem: shape,
            currentShape,
            infoBoxActive: true,
            saveActive: false,
            drawingMode: null,
            currentShapeActive: false,
            listItemActive: null
          });

          this.props.onShapeComplete(shape, currentShape);
        },
        onCenterChanged: () => {
          this.setState({
            center: refs.map.getCenter()
          });
        },
        onControlClick: (e, drawingMode) => {
          this.setState({
            infoBoxActive: false,
            saveActive: false,
            drawingMode
          });
        },
        onToggleList: e => {
          if (this.state.listActive) {
            this.setState({
              controlsActive: true,
              currentShapeActive: true,
              listItemActive: null
            });
          }
          this.props.onToggleList(e, !this.state.listActive);
          this.setState({ listActive: !this.state.listActive });
        },
        onSaveClick: e => {
          this.setState({ saveActive: true });
        },
        onDeleteClick: e => {
          const drawableItem = this.state.drawableItem;
          if (drawableItem !== null) {
            drawableItem.setMap(null);
          }
          this.setState({
            infoBoxActive: false,
            drawableItem: null,
            currentShape: null,
            warningActive: false
          });
        },
        onDeleteMarkerClick: e => {
          const currentMarker = null;
          this.setState({ currentMarker });
          this.props.onMarkerComplete(e, currentMarker);
        },
        onSaveLayerClick: e => {
          let drawableItem = this.state.drawableItem;
          if (drawableItem !== null) {
            drawableItem.title = this.state.shapeName;
            this.state.drawableList.push(drawableItem);
          }
          this.setState({
            saveActive: null,
            infoBoxActive: false
          });
          const currentShape = this.state.currentShape;
          currentShape.saved = true;
          currentShape.title = this.state.shapeName;
          currentShape.subtitle = "Subtext goes here";
          this.props.onSaveLayerClick(e, currentShape);
        },
        onGpsClick: e => {
          this.setState({ gpsActive: true });
          const position = navigator.geolocation.getCurrentPosition(
            position => {
              const center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.setState({ center, gpsActive: false });
            }
          );
        },
        onToggleSearchBar: e => {
          this.setState({ searchActive: !this.state.searchActive });
        },
        onItemClick: (e, index) => {
          const list = this.props.list;
          const currentShape = list[index];
          const center = currentShape.center;
          const drawableItem = this.state.drawableItem;
          if (drawableItem !== null) {
            drawableItem.setMap(null);
          }
          this.setState({
            controlsActive: false,
            center,
            listItemActive: index,
            currentShape,
            currentShapeActive: true,
            infoBoxActive: false
          });
          this.props.onShapeComplete(e, currentShape);
        },
        onMarkerComplete: marker => {
          const center = marker.getPosition();
          const currentMarker = {
            center,
            type: "marker"
          };
          marker.setMap(null);
          this.setState({ center, currentMarker });
          this.props.onMarkerComplete(marker, currentMarker);
        },
        onCenterChanged: () => {
          this.setState({
            center: refs.map.getCenter()
          });
        },
        onMarkerClick: marker => {
          const center = marker.getPosition();
          this.setState({ currentMarker: marker, center });
        },
        markers: [],
        onMapMounted: ref => {
          refs.map = ref;
        },
        onCloseInfoBox: () => {
          this.setState({ infoBoxActive: false, saveActive: false });
        },
        onBoundsChanged: () => {
          this.setState({
            bounds: refs.map.getBounds()
          });
        },
        onLayerInputChanged: event => {
          this.setState({ shapeName: event.currentTarget.value });
        },
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        onControlMounted: ref => {
          refs.control = ref;
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();
          places.forEach(place => {
            if (place.geometry.viewport) {
              bounds.union(place.geometry.viewport);
            } else {
              bounds.extend(place.geometry.location);
            }
          });
          const nextMarkers = places.map(place => ({
            position: place.geometry.location
          }));

          const nextCenter = _.get(
            nextMarkers,
            "0.position",
            this.state.center
          );

          this.setState({
            center: nextCenter,
            markers: nextMarkers
          });
        }
      });
    }
  }),
  withScriptjs,
  withGoogleMap
)(props => (
    props.showMap &&
    <GoogleMap
      className="testing"
      ref={props.onMapMounted}
      zoom={props.zoom}
      onCenterChanged={props.onCenterChanged}
      center={props.center}
      bounds={props.bounds}
      defaultOptions={props.defaultOptions}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        clickableIcons: false,
        styles: mapStyles
      }}
      onBoundsChanged={props.onBoundsChanged}
    >
      {props.infoBoxActive && (
        <InfoBox
          visible={props.infoBoxActive}
          position={
            new google.maps.LatLng(
              JSON.parse(JSON.stringify(props.currentShape.center))
            )
          }
          options={{
            boxClass: props.boxClass,
            closeBoxURL: ``,
            enableEventPropagation: true
          }}
        >
          <div className={classNames("info-box-container")}>
            <MPDButton
              className={classNames(
                "delete",
                !props.saveActive && mpdClasses.ACTIVE
              )}
              text="delete"
              onClick={props.onDeleteClick}
            />
            <MPDButton
              className={classNames(
                "save-layer",
                !props.saveActive && mpdClasses.ACTIVE
              )}
              text="Save Layer"
              onClick={props.onSaveClick}
            />
            <MPDButton
              text="save"
              className={classNames(
                "save",
                props.saveActive && mpdClasses.ACTIVE
              )}
              onClick={props.onSaveLayerClick}
            />
            <MPDButton
              name="compose-view--header--exit-transparent"
              className={classNames("close", mpdClasses.ACTIVE)}
              onClick={props.onCloseInfoBox}
            />
            {props.saveActive && (
              <input
                className={classNames(
                  "layer-name",
                  props.saveActive && mpdClasses.ACTIVE
                )}
                tabIndex={1}
                autoFocus={true}
                autoCapitalize={true}
                autoCorrect={false}
                onChange={props.onLayerInputChanged}
                placeholder="layer name..."
              />
            )}
          </div>
        </InfoBox>
      )}
      <Shapes
        shape={props.currentShapeActive ? props.currentShape : undefined}
        onShapeMounted={props.onShapeMounted}
      />
      {props.currentMarker &&
      !props.hideControls && (
        <InfoBox
          visible={props.currentMarker !== null}
          position={
            new google.maps.LatLng(
              JSON.parse(JSON.stringify(props.currentMarker.center))
            )
          }
          options={{
            boxClass: props.boxClass,
            closeBoxURL: ``,
            enableEventPropagation: true
          }}
        >
          <div className={classNames("info-box-container")}>
            <MPDButton
              className={classNames(
                "delete",
                !props.saveActive && mpdClasses.ACTIVE
              )}
              text="remove marker"
              onClick={props.onDeleteMarkerClick}
            />
            {/* <MPDButton
              name="compose-view--header--exit-transparent"
              className={classNames("close", mpdClasses.ACTIVE)}
              onClick={props.onCloseInfoBox}
            /> */}
          </div>
        </InfoBox>
      )}
      {props.currentMarker && (
        <div>
          <Marker
            position={props.currentMarker.center}
            icon={{
              url: window.devicePixelRatio > 1.0 ? marker2x : marker,
              scaledSize: new google.maps.Size(38, 56)
            }}
          />
        </div>
      )}
      {!props.hideControls && (
        <ZoomControls
          onZoomChanged={props.onZoomChanged}
          hide={props.hideZoomControls}
          zoomControlsActive={props.zoomControlsActive}
          alignment={props.zoomControlsAlignment}
        />
      )}
      {!props.hideGps &&
      !props.hideControls && (
        <MPDButton
          className={classNames(
            "gps-container",
            props.gpsActive && mpdClasses.ACTIVE,
            mpdClasses.alignmentClass(props.gpsAlignment || Alignment.LEFT)
          )}
          name="gps"
          selectName="gps-active"
          itemState={(props.gpsActive && States.selected) || States.default}
          onClick={props.onGpsClick}
        />
      )}
      {!props.hideControls && (
        <DrawControls
          controlsActive={props.controlsActive}
          drawingMode={props.drawingMode}
          hideDrawControls={props.hideDrawControls}
          align={props.drawControlsAlignment}
          defaultActive={google.maps.drawing.OverlayType.MARKER}
          onControlClick={props.onControlClick}
        />
      )}
      {!props.hideControls && (
        <List
          onToggleList={props.onToggleList}
          onToggleSearchBar={props.onToggleSearchBar}
          searchActive={props.searchActive}
          hide={props.hideList}
          onSearchChange={props.onSearchChange}
          listActive={props.listActive}
          searchValue={props.searchValue}
          onItemClick={props.onItemClick}
          list={props.list}
          listItemActive={props.listItemActive}
        />
      )}
      {!props.hideControls &&
      !props.hideList && (
        <MPDButton
          className={classNames(
            "geo-map-toggle-list",
            props.listActive && mpdClasses.ACTIVE,
            mpdClasses.alignmentClass(props.gpsAlignment || Alignment.RIGHT)
          )}
          onClick={!props.listActive && props.onToggleList}
          name="geo-layers"
          selectName="geo-layers-active"
          itemState={(props.listActive && States.selected) || States.default}
        />
      )}
      {!props.hideControls && (
        <DrawingManager
          defaultDrawingMode={google.maps.drawing.OverlayType.MARKER}
          onMarkerComplete={props.onMarkerComplete}
          drawingMode={props.drawingMode}
          onCircleComplete={shape => props.onShapeComplete(shape, "circle")}
          onRectangleComplete={shape => props.onShapeComplete(shape, "rectangle")}
          onPolygonComplete={shape => props.onShapeComplete(shape, "polygon")}
          defaultOptions={{
            polygonOptions: {
              draggable: true,
              editable: true,
              strokeColor: "#1f76ff",
              fillOpacity: 0.15,
              strokeWeight: 4,
              strokeOpacity: 1,
              strokeWeight: 5,
              clickable: false,
              zIndex: 1
            },
            rectangleOptions: {
              draggable: true,
              editable: true,
              strokeColor: "#1f76ff",
              fillOpacity: 0.15,
              strokeWeight: 4,
              strokeOpacity: 1,
              strokeWeight: 5,
              clickable: false,
              zIndex: 1
            },
            markerOptions: {
              draggable: true,
              strokeColor: "#1f76ff",
              fillOpacity: 0.15,
              strokeWeight: 4,
              strokeOpacity: 1,
              strokeWeight: 5,
              clickable: false,
              zIndex: 1
            },
            circleOptions: {
              editable: true,
              draggable: true,
              strokeColor: "#1f76ff",
              fillOpacity: 0.15,
              strokeWeight: 4,
              strokeOpacity: 1,
              strokeWeight: 5,
              clickable: false,
              zIndex: 1
            }
          }}
        />
      )}
      {!props.hideControls &&
      !props.hideSearchControls && (
        <SearchBox
          ref={props.onSearchBoxMounted}
          bounds={props.bounds}
          controlPosition={google.maps.ControlPosition.TOP_CENTER}
          onPlacesChanged={props.onPlacesChanged}
        >
          <div className="search-box-container">
            <MPDIcon name="geo-compose-search" />
            <input type="text" placeholder="Search address…" />
          </div>
        </SearchBox>
      )}
    </GoogleMap>
));



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/geo-map.js